{
  "Repo": "https://lba-consulting@dev.azure.com/lba-consulting/Abercrombie%20and%20Kent/_git/AK%20Frontend%20Reservation",
  "LastCommitHash": "f09300b90e5a6ba8870bbe681104e6e105862ff5",
  "LastCommitMessage": "Merge branch dev-update-version18 into dev-update-version19",
  "LastCommitAuthor": "roberto.dipiano",
  "LastCommitTime": "Tue Oct 27 18:23:01 2026 +0100",
  "VersionNumber": "21723"
}